import type { TypesOfHTMLElements } from "./types";

export const buildTrackingObj = (namespace: string, id: string) => ({
  id: `${namespace}-${id}`,
});

export const addHTMLEventID = (
  element: TypesOfHTMLElements,
  eventId: string,
) => {
  element.setAttribute("data-element-id", eventId);
};
